document.addEventListener(
  'DOMContentLoaded',
  function () {
    const orderReviewTable = jQuery("#order_review");
    if (!orderReviewTable) {
      return;
    }

    jQuery(document.body).on('payment_method_selected', function () {
      if (!isCheckout()) {
        const paymentMethodSelector = jQuery('.woocommerce-checkout input[name="payment_method"]:checked');
        if (paymentMethodSelector) {
          const selectedPaymentMethod = jQuery('.woocommerce-checkout input[name="payment_method"]:checked').attr('id');
          const paymentMethodIsPayoneer = selectedPaymentMethod === "payment_method_payoneer-checkout";
          hasPayoneerRows() && refreshTotals(paymentMethodIsPayoneer);
        }
      } else {
        jQuery(document.body).trigger('update_checkout');
      }
    });
    const isPayoneerRow = (el) => {
      return jQuery('span.payoneer-total', el).length !== 0;
    }
    const setupTableRows = () => {
      jQuery('#order_review tfoot tr').each(function () {
        const el = jQuery(this)
        el.addClass(isPayoneerRow(el) ? 'payoneer-total' : 'woo-total')
      });
    }

    setupTableRows()

    function refreshTotals(paymentMethodIsPayoneer) {
      if (paymentMethodIsPayoneer) {
        orderReviewTable.addClass('payment-method-payoneer');
      } else {
        orderReviewTable.removeClass('payment-method-payoneer');
      }
    }

    function isCheckout() {
      if (typeof window.wc_checkout_params === 'undefined') {
        return false;
      }
      return window.wc_checkout_params.is_checkout === '1';
    }

    function hasPayoneerRows() {
      return jQuery('span.payoneer-total').length !== 0;
    }
  },
  false,
);
